// extracted by mini-css-extract-plugin
module.exports = {"loadingEllipsis":"WaitingForRadar_loadingEllipsis__2e2Eh","ellipsis":"WaitingForRadar_ellipsis__3qLY_"};